module.exports = __webpack_public_path__ + "img/21.219e36b8.png";